import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const GoldCustomer: typeof SvgIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 2C6.47931 2 2 6.47932 2 12C2 17.5207 6.47931 22 12 22C17.5207 22 22 17.5207 22 12C22 6.47932 17.5207 2 12 2ZM14.7399 13.1047L16.8559 11.0646C16.9813 10.94 17.0126 10.7687 16.9969 10.6129C16.9499 10.4416 16.8089 10.3326 16.6364 10.3015L13.7211 9.88097L12.4201 7.24899C12.3418 7.09326 12.185 6.99982 12.0126 6.99982C11.8402 6.99982 11.6835 7.09326 11.6051 7.24899L10.3042 9.88097L7.38882 10.3015C7.2164 10.3326 7.07533 10.4572 7.02831 10.6129C6.96561 10.7687 7.01264 10.94 7.13804 11.0646L9.25402 13.1047L8.75244 15.9859C8.72109 16.1572 8.78379 16.3285 8.92485 16.422C9.00322 16.4687 9.09728 16.4998 9.19132 16.4998C9.25402 16.4998 9.33237 16.4842 9.39507 16.4531L11.997 15.0982L14.5988 16.4531C14.6615 16.4842 14.7242 16.4998 14.8026 16.4998C14.8966 16.4998 14.9907 16.4842 15.069 16.422C15.1944 16.3285 15.2728 16.1572 15.2415 15.9859L14.7399 13.1047Z"
            />
        </SvgIcon>
    );
};
